import { gsap } from "gsap";

export default class ProductRelatedEditorial {
	constructor(elm) {
        this.elm = elm;

        this.relatedEditorialOverlay = this.elm.querySelector('[data-related-editorial-overlay]');
        if(this.relatedEditorialOverlay) {
            this.init();
        }
    }

    init() {

		this.tl = gsap.timeline({
			paused: true,
			scrollTrigger: {
				trigger: this.elm,
				start: "top bottom",
				end: "bottom bottom",
				scrub: 0.3
			},
		});
		this.tl.fromTo(this.relatedEditorialOverlay, {
			opacity: 0,
		}, {
			opacity: 1,
			duration: 1,
			ease: 'none',
		});

    }

    destroy() {
		//
    }

}